
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ActionTypes } from "../actions/actionTypes";
import { IImpersonation } from "../../models/applicationState";
import { AnyAction } from "../actions/actionCreators";

/**
 * Reducer for recent projects. Actions handled:
 * LOAD_PROJECT_SUCCESS
 * SAVE_PROJECT_SUCCESS
 * DELETE_PROJECT_SUCCESS
 * SAVE_CONNECTION_SUCCESS
 * @param state - Array of recent projects
 * @param action - Action that was dispatched
 */
const initialState: IImpersonation = {
    impersonatedUser: null,
    impersonators: []
}


export const reducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case ActionTypes.LOAD_ALLOWED_IMPERSONATION:
        case ActionTypes.SET_IMPERSONATORS:
            return {...state, impersonators: action.payload}
        case ActionTypes.SET_IMPERSONATE_AS:
            return {...state, impersonatedUser: action.payload}
        default:
            return state;
    }
};
